// import Constants from '@/utils/Constants'

const state = {
	active: false,
	title: '',
	body: ''
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, {title, body}) {
		let parameters = {}
		if (title !== undefined) parameters.title = title
		if (body !== undefined) parameters.body = body

		if (state.active) {
			commit('hided')
			setTimeout(() => {
				commit('showed', parameters)
			}, 200)

		} else {
			commit('showed', parameters)
		}
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
	}
}

const mutations = {
	showed (state, {title, body}) {
		if (title !== undefined) state.title = title
		if (body !== undefined) state.body = body
		state.active = true
	},
	hided (state) {
		state.active = false
		state.title = ''
		state.body = ''
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
